import * as React from 'react';
import classNames from 'classnames/bind';
import { Link } from 'react-router-dom';
import { ISidebarLink } from '../components/Sidebar';

interface Props {
  value: ISidebarLink;
  currentPath: string;
  hideMenu: boolean;
  setPath: Function;
}

export const NavLink = (props: Props): React.ReactElement => (
  <Link
    to={props.value.link}
    data-cy={props.value.dataCy}
    onClick={(): void => props.setPath(props.value.link)}
    className={classNames({
      active: props.currentPath === props.value.link,
      small: props.hideMenu,
    })}
  >
    <span className="nav-icon" data-title={props.value.text} data-cy="sb-icon">
      <i className={props.value.icon} />
    </span>

    <span className={'nav-text'} data-cy="sb-text">
      {props.value.text}
    </span>
  </Link>
);
